module.exports = __webpack_public_path__ + "static/bookcover-f9f041cb0670f80372e073a425a0f747.jpg";